import { FC } from "react";
import { EuiProvider } from "@inscopix/ideas-eui";
import createCache from "@emotion/cache";

const cache = createCache({
  key: "ideas",
  container: document.querySelector('meta[name="emotion-style-insert"]') as
    | Node
    | undefined,
});
cache.compat = true;

export const ThemeProvider: FC = ({ children }) => {
  return (
    <EuiProvider
      cache={cache}
      colorMode="light"
      modify={{
        breakpoint: {
          xxl: 1366,
        },
      }}
    >
      {children}
    </EuiProvider>
  );
};
